import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import html2canvas from 'html2canvas';
import JSpdf from 'jspdf';


const page = {
  width: "750px",
  height: "1050px",
}

const header = {
  width: '750px',
  position : 'absolute',
  marginTop : '220px',
  textAlign: 'center',

}

const imagestyle = {
  position :'absolute',
  top : '20px',
  right : '20px'
}

const main = {
position : 'absolute',
top:'360px',
  width: '750px',
  textAlign : 'center'


}

const fooder = {
  width : '100%',
  textAlign : 'center',
  position: 'absolute',
  bottom : '20px',
}

const liststyle = {
  listStylePosition : 'inside'
}

let notshown = {
  transform : 'translate(120%)',
  position : 'fixed'
}



export default class Bescheinigung extends React.Component {
  constructor(props) {
    super(props)
  this.state = {'open' : false}
}

componentDidMount () {

}

componentDidUpdate(prevProps) {
  if (this.props.print) {
    this.printDocument()
    this.props.onPrinted(true)
  }
}

printDocument= () => {
  console.log('print')
  const input = document.getElementById('bescheinigung');
  html2canvas(input,{scale:3,allowTaint : true,useCORS: true})
    .then((canvas) => {
      console.log('c',canvas)
      const imgData = canvas.toDataURL('image/jpeg'); 
      const pdf = new JSpdf("p","pt","a4", true);
      const ratio = canvas.width / canvas.height
      console.log('r',ratio)
      const img = new Image()
      const headimage = new Image()
      //headimage.crossOrigin = '*';  //<-- set here
      headimage.src = "https://fb.rdheinsberg.de/rest/image/rdhsheadlogo.jpg"
      pdf.addImage(imgData, 'png', 20 , 20, 576 , 808,'','MEDIUM'); ;
      // pdf.output('dataurlnewwindow');
      const name = this.props.lectureName.replace(' ','_')
      pdf.save('Bescheinigung_'+name+'.pdf');
    }).catch(function (error) {
      console.log('errpr',error);
    });
  ;
}



render() {
  const {userdata,lectureContent,lectureName,typ,lectureDuration,test} = this.props
  const {start,end,points,maxpoints} = test || {}
  return (
    <div style={notshown}>
      <Paper id="bescheinigung" style={page}>
      <img src="https://fb.rdheinsberg.de/rest/image/rdhsheadlogo.jpg" style={imagestyle}/>
      <div style={header}>
      <Typography variant="h4" id="tableTitle">
        {typ === 'Fortbildung' ? 'Fortbildungsbescheinigung' : 'Unterweisungsbescheinigung'}
      </Typography>
      </div><br/>
      <div style={main}>
      {userdata.name ? (userdata.name.vorname+' '+userdata.name.nachname) : userdata.username}
      <br/>
      hat am<br/>
      {end}<br/><br/>
      die {typ === 'Fortbildung' ? 'Fortbildung' : 'Unterweisung'}<br/><br/>
      <Typography variant="h6" id="tableTitle">
      {lectureName}
      </Typography><br/><br/>
      {lectureContent.length > 0 && <div>
        mit folgendem Inhalt:
        <ul style={liststyle}>
          {lectureContent.map((k,i) => (
            <li>{k}</li>
          ))
          }
        </ul>
        <br/>
      </div>
      }
      {(typ == 'Fortbildung') && <>
      <Typography variant="body1">im Zeitumfang von {lectureDuration} Stunden</Typography>
        <br/>
      </>
      }
      erfolgreich abgeschlossen.
      </div>
      <div style={fooder}>
          Rettungsdienst im Kreis Heinsberg gGmbH, Rheinstr. 105, 41836 Hückelhoven, Telefon 02452/ 133 820 https://www.rd-heinsberg.de
      </div>
      </Paper>
    </div>
  )
}

}
